import React, { useEffect, useState } from "react";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";

import { Navigate, useNavigate, useParams, Link } from "react-router-dom";
import axios from "axios";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Deliverynoteinward_new = () => {
  useAuthRedirect();
    const { delNo } = useParams();

    const [headerDetails, setHeaderDetails] = useState({});
    const [itemDetails, setItemDetails] = useState([]);
    const [formData, setFormData] = useState([]);
    const navigate = useNavigate();

              const canEntry = hasPermission("Vehicle Delivery Note Inward", "entry");

    useEffect(() => {
        const fetchDetails = async () => {
            if (!delNo) {
                console.log("No Delivery Note Number (delNo) provided");
                return;
            }
            try {
                 Swal.fire({
                                        title: "Fetching Delivery Note Details",
                                        html: `
                                          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                                            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                                          </div>
                                          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Delivery Note Details...</p>
                                        `,
                                        showConfirmButton: false,
                                        allowOutsideClick: false,
                                        didOpen: () => {
                                          const style = document.createElement("style");
                                          style.innerHTML = `
                                            @keyframes progressBar {
                                              0% { width: 0% }
                                              50% { width: 100% }
                                              100% { width: 0% }
                                            }
                                          `;
                                          document.head.appendChild(style);
                                        },
                                      });
                console.log(`Fetching details for Delivery Note No: ${delNo}`);
                const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/deliveryNote_detail?delNo=${delNo}`);

                console.log("API Response:", response.data);

                if (response.data && response.data.deliveryDetail?.length > 0) {
                    const items = response.data.deliveryDetail;

                    const header = {
                        del_no: items[0].del_no || "N/A",
                        del_id: items[0].del_id || "N/A",
                        frombranch: items[0].frombranch || "N/A",
                        tobranch: items[0].tobranch || "N/A",
                        del_send: items[0].del_send || "N/A",
                        del_date: items[0].del_date || "N/A",
                    };

                    setHeaderDetails(header);
                    setItemDetails(items);

                    setFormData(items.map(item => ({
                        del_no: item.del_no,
                        del_id: item.del_id,
                        del_description: item.del_description || "",
                        recQty: "",
                        balQty: ""
                    })));
                } else {
                    console.warn("API Response does not contain expected data structure");
                }
                Swal.close();
            }  catch (error) {
                    Swal.close();
                                 console.error("Error fetching Delivery Note Details. Please try again:", error);
                                 Swal.fire({
                                   icon: "error",
                                   title: "Oops!",
                                   text: "Error fetching Delivery Note Details. Please try again",
                                 });
                  }
        };
{canEntry && (
        fetchDetails()
)}
    }, [delNo]);

    const handleChange = (index, e) => {
        const { name, value } = e.target;
    
        setFormData(prevData => {
            const updatedData = [...prevData];  
            updatedData[index] = { ...updatedData[index], [name]: value }; 
            return updatedData;
        });
    };

    const validateItemDetails = () => {
  for (let i = 0; i < itemDetails.length; i++) {
    const recQty = formData[i]?.recQty;
    const balQty = formData[i]?.balQty;
    const delQty = parseFloat(itemDetails[i]?.Del_Qty || 0);

    const rec = parseFloat(recQty);
    const bal = parseFloat(balQty);

    if (!recQty?.trim() || !balQty?.trim()) {
      Swal.fire({
        icon: "warning",
        title: `Empty Field (Row ${i + 1})`,
        text: "Please enter both Received Qty and Balance Qty.",
      });
      return false;
    }

    if (isNaN(rec) || isNaN(bal)) {
      Swal.fire({
        icon: "error",
        title: `Invalid Number (Row ${i + 1})`,
        text: "Received Qty and Balance Qty must be numeric.",
      });
      return false;
    }

    if (rec < 0 || bal < 0) {
      Swal.fire({
        icon: "error",
        title: `Negative Quantity (Row ${i + 1})`,
        text: "Quantities cannot be negative.",
      });
      return false;
    }

   if (rec + bal !== delQty) {
  Swal.fire({
    icon: "warning",
    title: `Mismatch in Total Qty (Row ${i + 1})`,
    text: `Received Qty + Balance Qty must exactly equal Delivered Qty (${delQty}).`,
  });
  return false;
}

  }

  return true;
};

     
 const handleSubmit = async (e) => {
  e.preventDefault();

  const isValid = validateItemDetails();
  if (!isValid) return; // Stop if validation fails

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.put(
      "https://rfs2.infraconsoft.net.in/api/inward_update",
      { items: formData },
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    console.log("Response:", response.data);
    Swal.fire("Success", "Data updated successfully!", "success");
    navigate("/delNoteInwardVehicle");
  } catch (error) {
    console.error("Error submitting form:", error.response?.data || error.message);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};

if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
   
    return (
        <div id="admin-container">
            <AdminNav />
            <div className="content-right">
                <section>
                    
                    <div className="back-div">
                              <h2 className="add-txt">Delivery Note Details</h2>
                              <Link to='/delNoteInwardVehicle'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                            </div>
                    <Time />
                </section>

                <div className="form-container">
                    <form className="vehicle-form" onSubmit={handleSubmit}>
                        <div className="form-row">
                            <div className="form-group">
                                <label>Del No :</label>
                                <input type="text" value={delNo} readOnly />
                            </div>
                            <div className="form-group">
                                <label>Date :</label>
                                <input
  type="text"
  value={
    headerDetails?.del_date
      ? new Date(headerDetails.del_date).toLocaleDateString("en-GB") // d/m/y
      : "N/A"
  }
  readOnly
/>

                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>From Branch :</label>
                                <input type="text" value={headerDetails?.frombranch || "N/A"} readOnly />
                            </div>
                            <div className="form-group">
                                <label>To Branch :</label>
                                <input type="text" value={headerDetails?.tobranch || "N/A"} readOnly />
                            </div>
                        </div>

                        <div className="form-row">
                            <div className="form-group">
                                <label>Send Through :</label>
                                <input type="text" value={headerDetails?.del_send || "N/A"} readOnly />
                            </div>
                            <div className="form-group">
                                <label></label>
                                <input type="hidden" />
                            </div>
                        </div>

                        <table className="items-table">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Descriptions</th>
                                    <th>Del.Qty</th>
                                    <th>Rec.Qty</th>
                                    <th>Bal.Qty</th>
                                    <th>Remarks</th>
                                </tr>
                            </thead>
                            <tbody>
    {itemDetails.length > 0 ? (
        itemDetails.map((item, index) => (
            <tr key={index}>
                <td>{index + 1}</td>
                <td>{item.del_description || "N/A"}</td>
                <td>{item.Del_Qty || 0}</td>
                <td>
                    <input
                        type="text"
                        name="recQty"
                        value={formData[index]?.recQty || ""}
                        onChange={(e) => handleChange(index, e)}
                    />
                </td>
                <td>
                    <input
                        type="text"
                        name="balQty"
                        value={formData[index]?.balQty || ""}
                        onChange={(e) => handleChange(index, e)}
                    />
                </td>
                <td>{item.del_remarks || "N/A"}</td>
            </tr>
        ))
    ) : (
        <tr>
            <td colSpan="6" style={{ textAlign: "center" }}>No items found</td>
        </tr>
    )}
</tbody>


                        </table>
                        <div className="btn-cls">
                            <button type="submit" className="submit-btn">Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Deliverynoteinward_new;
